import React from 'react';
import ComplaintHead from './ComplaintHead';
import Complaint from './Complaint';

const ComplaintPage = () => {
  return (
    <>
      <ComplaintHead />
      <Complaint />
    </>
  );
};

export default ComplaintPage;
